import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get tokens from localStorage
    const adminToken = localStorage.getItem('adminToken');
    const gameToken = localStorage.getItem('gameToken');
    const language = localStorage.getItem('language') || 'tr';

    let authReq = req.clone({
      setHeaders: {
        'Accept-Language': language,
        'Content-Type': 'application/json'
      }
    });

    // Add appropriate token based on the endpoint
    if (adminToken && (
      req.url.includes('/AdminAuth/') || 
      req.url.includes('/Category/') || 
      req.url.includes('/Sentence/') || 
      req.url.includes('/File/') ||
      req.url.includes('/Badge/') ||
      req.url.includes('/User/') ||
      req.url.includes('/Notification/') ||
      req.url.includes('/Analysis/')
    )) {
      authReq = authReq.clone({
        setHeaders: {
          'AdminUserToken': adminToken
        }
      });
    } else if (gameToken && req.url.includes('/Auth/')) {
      authReq = authReq.clone({
        setHeaders: {
          'GameUserToken': gameToken
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Unauthorized - clear tokens and redirect to login
          localStorage.removeItem('adminToken');
          localStorage.removeItem('gameToken');
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }
}
